document.querySelectorAll('.HouseListFilters__tags').forEach((el) => {
    const btn = el.querySelector('.HouseListFilters__other');

    btn.addEventListener('click', () => {
        const count = el.querySelectorAll('.HouseListFilters__line').length;
        const cssVar = +getComputedStyle(el).getPropertyValue('--lines');

        const newVal = cssVar === 2 ? count : 2;
        el.style.setProperty('--lines', newVal.toString());
    });
})

document.querySelectorAll('.HouseListFilters').forEach((el) => {
    const btnLoad = el.querySelector('.HouseListFilters__load button');
    const listEl = el.querySelector('.HouseItemList');

    if(btnLoad) {
        btnLoad.addEventListener('click', () => {
            fetch(btnLoad.dataset.url).then((r) => r.text()).then((html) => {
                const count = listEl.childElementCount;
                listEl.innerHTML += html;
                Array.from(listEl.children).slice(count-1).forEach(HouseItemInit);
            })
        });
    }
})
